import API from 'lib/api'
import CardGif from './card-gif'
import GIF from 'app/records/gif'
import React, { PropTypes } from 'react'
import debounce from 'lodash.debounce'

const GifPicker = React.createClass({

  propTypes: {
    onSelect: PropTypes.func.isRequired
  },

  getInitialState() {
    return { images: [] }
  },

  setRandomImage() {
    const pool = this.state.images.filter(image => image.src !== this.props.selected)
    const next = pool[Math.random() * pool.length | 0]

    this.props.onSelect(next ? next.src : null)
  },

  searchDidSucceed(raw) {
    this.setState({
      images : raw.map(image => new GIF(image))
    }, this.setRandomImage)
  },

  search(term) {
    if (term.length < 1) {
      return this.setState({ images: [] })
    }

    API.gifs.read({
      query: {
        q: term
      }
    }).done(this.searchDidSucceed)
  },

  componentWillMount() {
    this.debouncedSearch = debounce(this.search, 250)
  },

  componentWillReceiveProps(newProps) {
    if (this.props.term !== newProps.term) {
      this.debouncedSearch(newProps.term)
    }
  },

  render() {
    let className = this.props.selected ? 'gif-picker' : 'gif-picker gif-picker--empty'

    return (
      <div className={ className } aria-hidden="true">
        <CardGif gif={ this.props.selected } />
        { this.state.images.length > 1 ? this.renderShuffler() : null }
      </div>
    )
  },

  renderShuffler() {
    return (
      <button className="gif-picker__shuffler" type="button" onClick={ this.setRandomImage }>
        <span className="hide-visually">Refresh</span>
      </button>
    )
  }

})

export default GifPicker



/** WEBPACK FOOTER **
 ** ./web/static/app/components/game/gif-picker.jsx
 **/